import Pool from './pages/pool/Pool';
import Gamebar from './component/gamebar/Gamebar';
import './styles/App.scss';
import Router from './Router';

function App() {
	return <Router />;
}

export default App;
